import { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { BarChart } from '@/components/charts/BarChart';
import { DailyHeatmap } from '@/components/charts/DailyHeatmap';
import { CHART_HOME, dailySample, monthlySample, moneyTick, moneyValue } from '../charts/model';
import { Section, Code } from './Section';
export function ChartPatternsSection() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== '#chart-patterns') return;
    let active = true;
    const align = () => {
      if (active)
        document.getElementById('chart-patterns')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    const frame = requestAnimationFrame(align);
    void document.fonts.ready.then(align);
    return () => {
      active = false;
      cancelAnimationFrame(frame);
    };
  }, [hash]);
  const monthly = monthlySample('2025'),
    daily = dailySample('2025', 'requests');
  return (
    <Section
      id="chart-patterns"
      title="Графики по месяцам и дням"
      lead="Одна шкала для сравнения, точные значения и управление с клавиатуры. Общие элементы для любого сервиса."
    >
      <div className="grid items-start gap-6 md:grid-cols-2">
        <div className="min-w-0 rounded-lg border border-line bg-card p-4 sm:p-5">
          <h3 className="mb-5 type-heading">Столбцы по месяцам</h3>
          <BarChart
            label="Средства за первое полугодие 2025"
            categories={monthly.categories.slice(0, 6)}
            series={monthly.series.map((s) => ({ ...s, values: s.values.slice(0, 6) }))}
            formatValue={moneyValue}
            formatTick={moneyTick}
            axisLabel="тыс. ₽"
          />
          <p className="mt-4">
            <Code>BarChart · ноль / пропуск / отрицательные</Code>
          </p>
        </div>
        <div className="min-w-0 rounded-lg border border-line bg-card p-4 sm:p-5">
          <h3 className="mb-5 type-heading">Тепловая карта</h3>
          <DailyHeatmap label="Обращения за январь — февраль 2025" {...daily} to="2025-02-28" unit="шт." />
          <p className="mt-4">
            <Code>DailyHeatmap · дни / недели / точная таблица</Code>
          </p>
        </div>
      </div>
      <Link
        to={CHART_HOME}
        className="inline-flex h-9 items-center gap-2 self-start rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        Открыть образец
        <ArrowRight className="size-4" />
      </Link>
    </Section>
  );
}
